import { FontEntry } from '../../types/font'

import { cabin } from './cabin'
import { cinzel } from './cinzel'
import { everett } from './everett'
import { poppins } from './poppins'
import { raleway } from './raleway'
import { roboto } from './roboto'
import { robotoFlexTtt } from './roboto-flex-ttt'
import { sailec } from './sailec'
import { tomorrow } from './tomorrow'

export const FONT_FILES: Record<string, FontEntry> = {
  cabin,
  cinzel,
  poppins,
  everett,
  raleway,
  roboto,
  'roboto-flex-ttt': robotoFlexTtt,
  sailec,
  tomorrow
}

export const getFontFaceStyles = (formattedName: string) => {
  const entry = FONT_FILES[formattedName]
  if (!entry) return ''

  if (entry.variables) {
    const { displayName, variables } = entry

    return (['normal', 'italic'] as const)
      .filter((style) => variables[style])
      .map((style) => {
        const font = variables[style]!
        const weightRange = font.weightRange
          ? `${font.weightRange[0]} ${font.weightRange[1]}`
          : '100 900'

        return `
@font-face {
  font-family: '${displayName}';
  font-style: ${style};
  font-weight: ${weightRange};
  font-display: swap;
  src: url('https://cdn.courseticket.com/s/fonts/${font.file}.${font.extension}') format('${font.format}');
}`
      })
      .join('\n')
  }

  const { displayName, weights } = entry

  return Object.entries(weights)
    .map(([weightStr, styles]) => {
      const weight = Number(weightStr)
      return (['normal', 'italic'] as const)
        .map((style) => {
          const fontFile = styles[style]
          if (!fontFile) return ''
          return `
@font-face {
  font-family: '${displayName}';
  font-style: ${style};
  font-weight: ${weight};
  font-display: swap;
  src: url('https://cdn.courseticket.com/s/fonts/${fontFile.file}.${fontFile.extension}') format('${fontFile.format}');
}`
        })
        .join('\n')
    })
    .join('\n')
}
